import { AGGREGATOR_BASE_URL } from 'src/environments/base-url';

export const uploadWidgetRecordsUrl = (): string => `${AGGREGATOR_BASE_URL}/upload-widget/records`;

export const uploadWidgetRecordUrl = (uuid: string): string => `${uploadWidgetRecordsUrl()}/${uuid}`;

export const uploadWidgetRecordReportUrl = (uuid: string): string => `${uploadWidgetRecordUrl(uuid)}/report`;
